import { useQuery } from '@tanstack/react-query';

import { get } from 'idb-keyval';

export const getKey = photoSessionId => [
  'local-assessment',
  Number(photoSessionId),
];

export const getIDBKey = photoSessionId => getKey(photoSessionId).join('-');

const useLocalAssessment = (photoSessionId, options) =>
  useQuery({
    queryKey: getKey(photoSessionId),
    queryFn: async () => {
      try {
        const value = await get(getIDBKey(photoSessionId));
        return value || null;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    enabled: !!photoSessionId,
    ...options,
  });

export default useLocalAssessment;
